// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"0735a0e2","234":"c6d65b5d","523":"c6d65b5d","653":"0735a0e2","673":"0735a0e2","996":"0735a0e2"}[chunkId] + ".chunk.css";
};